"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchUser = patchUser;
const axios_1 = __importDefault(require("axios"));
const api_utils_1 = require("./api-utils");
const constants_1 = require("./constants");
// import LoginDataForm from "models/forms/login-data-form"; missing dependecy
const axios = axios_1.default.create({
    baseURL: constants_1.COGSWORTH_URL,
    withCredentials: true,
    validateStatus: (status) => {
        return status >= 200 || status === 400;
    },
});
async function patchUser(
// form: LoginDataForm
form) {
    let response;
    if (form.password) {
        response = await axios.post(`update_login_info`, (0, api_utils_1.toSnakeCase)({ user: form }));
    }
    else {
        response = await axios.post(`update_login_info`, (0, api_utils_1.toSnakeCase)({ user: { email: form.email } }));
    }
    const result = (0, api_utils_1.fromSnakeCase)(response.data);
    if (response.status === 400) {
        return Promise.reject({ status: 400, validationErrors: result.data.user });
    }
    let email;
    if (response.status === 204) {
        email = form.email;
    }
    else {
        email = result.user.email;
    }
    return email;
}
